import styled from 'styled-components';

export const TableContainer = styled.div`
  margin-bottom: 50px;
  position: relative;
`;

export const Title = styled.div`
  color: #222;
  margin-bottom: 1rem;
  font-family: 'HNforTELUSSA500normal', 'Helvetica Now', 'Helvetica Neue',
    Helvetica, Arial, sans-serif !important;
  font-weight: 500;
  font-size: 18px;
  text-align: center;
`;

export const GroupOverlayCenter = styled.div`
  position: fixed; /* Use fixed to position relative to the viewport */
  top: 50%; /* Center vertically */
  left: 50%; /* Center horizontally */
  transform: translate(-50%, -50%); /* Adjust for the element's size */
  width: 110%;
  height: 110%;
  z-index: 9;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
`;

export const GroupOverlay = styled.div`
  position: absolute;
  top: -15px;
  left: -15px;
  width: 110%;
  height: 110%;
  z-index: 9;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.3);
`;

export const GroupOverlayInner = styled.div`
  width: 40%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;

export const GroupTitleContainer = styled.div`
  // width: 50%;
  margin-bottom: 10px;
`;

export const GroupTitle = styled.div`
  color: #4b286d;
  font-size: 1.2rem;
`;

export const Table = styled.table`
  margin-bottom: 10px;
`;

export const Thead = styled.thead`
  background: #f2f2f2;
`;

export const Tr = styled.tr`
  border: 1px solid #e3e3e3;
`;

export const Td = styled.td`
  background: ${({ background }) => background || '#ffffff'};
  border: 1px solid #e3e3e3;
  // text-align: center;
  // vertical-align: middle;
`;

export const TdPrice = styled.td`
  position: relative;
  border: 1px solid #e3e3e3;
  // text-align: center;
  // vertical-align: middle;
`;

export const Th = styled.th`
  padding-top: 10px;
  background: #4b286d;
  color: #fff;
`;

export const AddRemoveButton = styled.div`
  position: absolute;
  top: 50%;
  right: -60px;
  display: flex;
  gap: 0.25rem;
  transform: translate(0, -50%);
`;

export const LabelWrapper = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ justify }) => justify || 'flex-start'};
  gap: 0.5rem;
`;

export const SVGWrapper = styled.span`
  cursor: pointer;
`;

export const ButtonLink = styled.button`
  border: 0;
  background: none;
  display: flex;
  gap: 0.25rem;
  align-items: center;
  font-size: ${({ size }) => `${size}px` || '16px'};
  color: ${({ color }) => color || ''};
`;

export const ButtonLinkDelete = styled.button`
  border: 1px solid #f1d2d5;
  background: #fff6f8;
  padding: 0.5rem 1rem;
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  gap: 0.25rem;
  align-items: center;
  font-size: 14px;
  color: #c12335;
`;

export const ButtonLight = styled.button`
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  background: #f3f3f3;
  padding: 0.5rem 1.5rem;
  text-decoration: none;
  display: flex;
  gap: 0.25rem;
  align-items: center;
  font-size: 14px;
`;

export const RequiredLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #c12335;
  letter-spacing: 0.2px;
  margin: 3px;
`;

export const ServiceWrapper = styled.div`
  position: relative;
  margin-bottom: 2rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  gap: 1.25rem;
  flex-direction: column;
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const InputLabel = styled.div`
  position: absolute;
  font-size: 11px;
  top: -8px;
  left: 50%;
  background: #fff;
  padding: 0 7px;
  color: #787878;
  font-weight: 600;
  letter-spacing: 0.1px;
  transform: translate(-50%);
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  font-size: 14px;
  justify-content: space-between;
`;

export const PriceLabel = styled.span`
  color: #898989;
`;

export const PriceContent = styled.span`
  font-weight: 600;
  letter-spacing: 0.1px;
`;

export const NoteLabel = styled.div`
  font-size: 13px;
  color: #676767;
  font-family: 'HNforTELUSSA500normal', 'Helvetica Now', 'Helvetica Neue',
    Helvetica, Arial, sans-serif !important;
  font-weight: 500;
`;

export const CheckBoxWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
`;

export const CheckBoxLabel = styled.div`
    font-size: 14px;
    color: #333;
    font-family: 'HNforTELUSSA500normal', 'Helvetica Now', 'Helvetica Neue',
      Helvetica, Arial, sans-serif !important;
    font-weight: 500;
    cursor: pointer;
`;

export const StyledCheckBox = styled.input.attrs({type: 'checkbox'})`
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #4a90e2;
    border: 1px solid #ccc;
    border-radius: 3px;
`;
